import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <>
      <div className="flex gap-4 px-5">
        {/* Left side - Green gradient with welcome message */}
        <div className="hidden border-b-[12px] border-b-solid border-b-white border-t-[12px] border-t-solid border-t-white md:flex min-h-screen items-center bg-gradient-to-r from-green-700 via-green-600 to-green-500 md:w-2/6 lg:w-3/6 rounded-[35px]">
          <div className="text-white px-5 lg:px-0 lg:ml-[100px] space-y-8 lg:space-y-[60px]">
            <h2 className="text-3xl lg:text-[45px] font-semibold underline underline-offset-[14px]">
              Cabinet Compassion
            </h2>
            <p className="text-lg lg:text-xl leading-relaxed text-justify">
              Votre santé, notre priorité. Des soins de qualité avec compassion et professionnalisme.
            </p>
          </div>
        </div>

        {/* Right side - Content about the cabinet */}
        <div className="min-h-screen flex items-center w-full md:w-4/6 lg:w-3/6 px-5 sm:px-20 py-10">
          <div className="w-full space-y-8">
            <div>
              <h1 className="text-slate-700 text-4xl lg:text-5xl font-bold mb-4">
                Bienvenue au Cabinet Compassion
              </h1>
              <p className="text-slate-600 text-lg leading-relaxed text-justify">
                Un cabinet médical moderne dédié à votre bien-être et à votre santé.
              </p>
            </div>

            <div className="space-y-6 mt-8">
              <div className="bg-green-50 p-6 rounded-lg border-l-4 border-green-500">
                <h3 className="text-slate-700 text-2xl font-semibold mb-3 flex items-center">
                  <i className="bx bx-heart text-green-600 mr-4 text-3xl"></i>
                  Notre Mission
                </h3>
                <p className="text-slate-600 leading-relaxed text-justify">
                  Le Cabinet Compassion s'engage à fournir des soins médicaux de qualité supérieure 
                  dans un environnement chaleureux et accueillant. Nous mettons l'accent sur la 
                  compassion, l'écoute et l'excellence médicale pour chaque patient.
                </p>
              </div>

              <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-500">
                <h3 className="text-slate-700 text-2xl font-semibold mb-3 flex items-center">
                  <i className="bx bx-user-check text-blue-600 mr-4 text-3xl"></i>
                  Nos Services
                </h3>
                <ul className="text-slate-600 space-y-2 list-disc list-outside pl-6">
                  <li>Consultations médicales générales</li>
                  <li>Suivi des patients chroniques</li>
                  <li>Gestion des rendez-vous en ligne</li>
                  <li>Prescriptions et ordonnances électroniques</li>
                  <li>Suivi des bilans et examens médicaux</li>
                  <li>Gestion des assurances et facturation</li>
                </ul>
              </div>

              <div className="bg-purple-50 p-6 rounded-lg border-l-4 border-purple-500">
                <h3 className="text-slate-700 text-2xl font-semibold mb-3 flex items-center">
                  <i className="bx bx-star text-purple-600 mr-4 text-3xl"></i>
                  Nos Valeurs
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-slate-600">
                  <div className="flex items-center gap-5 py-2">
                    <i className="bx bx-check-circle text-green-600 text-2xl flex-shrink-0"></i>
                    <span className="text-base">Excellence médicale</span>
                  </div>
                  <div className="flex items-center gap-5 py-2">
                    <i className="bx bx-check-circle text-green-600 text-2xl flex-shrink-0"></i>
                    <span className="text-base">Compassion et empathie</span>
                  </div>
                  <div className="flex items-center gap-5 py-2">
                    <i className="bx bx-check-circle text-green-600 text-2xl flex-shrink-0"></i>
                    <span className="text-base">Confidentialité garantie</span>
                  </div>
                  <div className="flex items-center gap-5 py-2">
                    <i className="bx bx-check-circle text-green-600 text-2xl flex-shrink-0"></i>
                    <span className="text-base">Innovation technologique</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-10 pt-8 border-t border-gray-200">
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center max-w-2xl mx-auto">
                <Link
                  to="/login"
                  className="w-full sm:w-auto sm:min-w-[280px] bg-green-500 hover:bg-green-600 shadow-lg hover:shadow-xl text-white text-base sm:text-lg font-semibold py-4 px-6 rounded-lg transition-all duration-300 text-center flex items-center justify-center gap-2 transform hover:scale-105"
                >
                  <i className="bx bx-log-in text-xl"></i>
                  <span>Accéder à l'espace personnel</span>
                </Link>
                <Link
                  to="/privacy-policy"
                  className="w-full sm:w-auto sm:min-w-[280px] bg-white hover:bg-slate-50 border-2 border-slate-300 hover:border-slate-400 text-slate-700 text-base sm:text-lg font-semibold py-4 px-6 rounded-lg transition-all duration-300 text-center flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
                >
                  <i className="bx bx-info-circle text-xl"></i>
                  <span>En savoir plus</span>
                </Link>
              </div>
            </div>

            <div className="mt-6 pt-6 border-t border-gray-200">
              <div className="flex flex-col sm:flex-row justify-center items-center gap-4 text-sm">
                <Link
                  to="/privacy-policy"
                  className="text-slate-500 hover:text-green-600 transition-all duration-300"
                >
                  Politique de Confidentialité
                </Link>
                <span className="text-slate-300 hidden sm:inline">|</span>
                <Link
                  to="/terms-of-service"
                  className="text-slate-500 hover:text-green-600 transition-all duration-300"
                >
                  Conditions d'Utilisation
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;

